import { Routes } from '@angular/router';
import { antRoutes } from './antRoutes';
import { insightRoutes } from './insightRoutes';
import { planRoutes } from './planRoutes';
import { proRoutes } from './proRoutes';
import { rateControllerRoutes } from './rateControllerRoutes';
import { shiftRoutes } from './shiftRoutes';
import { tksRoutes } from './tksRoutes';

export const pulseRoutes: Routes = [
    { path: 'ant', children: antRoutes },
    { path: 'insight', children: insightRoutes },
    { path: 'pro', children: proRoutes },
    { path: 'tks', children: tksRoutes },
    { path: 'rate', children: rateControllerRoutes },
    { path: 'shift', children: shiftRoutes },
    { path: 'plan', children: planRoutes },
];
